import { HiArrowRight } from "react-icons/hi";
import "./searchdrawer.css";
import SearchDropSwiper from "../../Header/SearchDropSwiper/SearchDropSwiper";
const SearchDrawer = ({
  close,
  categories,
  products,
  articles,
  searchQuery,
  setSearchQuery,
  searchDebounce,
}) => {
  console.log("searchQuery", products, categories, searchQuery);
  return (
    <div className="search_drawer">
      <div className="search_drawer-box mb-3">
        <HiArrowRight
          className="search_drawer-back"
          size={20}
          color="#3f4064"
          onClick={close}
        />
        <input
          type="search"
          placeholder="جستجو"
          className="search_drawer-input"
          value={searchQuery}
          onChange={(e) => {
            searchDebounce.current(e.target.value);
            setSearchQuery(e.target.value);
          }}
        />
      </div>
      {/* <div className="last_searchs mb-3">
        <div className="last_search">
          <HiOutlineClock size={20} color="#9e9fb1" className="ms-2" />
          <span>آخرین جستجوی شما</span>
        </div>
        <div className="trash_bin">
          <ImBin size={20} color="#aaabbb" className="trash_bin-icon" />
        </div>
      </div> */}
      {/* <div className="last_Search-text pe-4 mb-5">
        <div className="last_Search-body ms-3">
          <span>موبایل</span>
          <BiChevronLeft size={20} color="#48496b" />
        </div>
        <div className="last_Search-body ms-3">
          <span>موبایل</span>
          <BiChevronLeft size={20} color="#48496b" />
        </div>
      </div> */}
      {searchQuery?.length > 0 &&
        (categories.length !== 0 ? (
          <div>
            <div>دسته بندی ها: </div>
            <SearchDropSwiper
              data={categories}
              type={"category"}
              close={close}
            />
          </div>
        ) : (
          <></>
          // <div
          //   style={{
          //     justifyContent: "center",
          //     display: "flex",
          //     fontSize: "16px",
          //   }}
          // >
          //   دسته بندی با این مشخصات یافت نشد
          // </div>
        ))}
      {searchQuery?.length > 0 && (
        <>
          <hr />{" "}
          {products.length !== 0 ? (
            <div>
              <div>محصولات: </div>
              <SearchDropSwiper
                data={products}
                type={"product"}
                searchQuery={searchQuery}
                close={close}
              />
            </div>
          ) : (
            <div
              style={{
                justifyContent: "center",
                display: "flex",
                fontSize: "16px",
              }}
            >
              محصولی با این مشخصات یافت نشد
            </div>
          )}
        </>
      )}
      {searchQuery?.length > 0 && (
        <>
          <hr />
          {articles.length !== 0 ? (
            <div>
              <div>مقالات: </div>
              <SearchDropSwiper
                data={articles}
                type={"article"}
                searchQuery={searchQuery}
                close={close}
              />
            </div>
          ) : (
            <></>
            // <div
            //   style={{
            //     justifyContent: "center",
            //     display: "flex",
            //     fontSize: "16px",
            //   }}
            // >
            //   مقاله ای با این مشخصات یافت نشد
            // </div>
          )}
        </>
      )}
      {/* <hr />
      <div className="search_hot">
        <div className="search_hot-body mb-3">
          <FaHotjar size={20} color="#3f4064" className="ms-2" />
          <span>جستجو های پرطرفدار</span>
        </div>
        <div className="search_hot-text pe-4">
          <div className="search_hot-card ms-3">
            <span>کفش طبیعت گردی زنانه</span>
            <BiChevronLeft size={20} color="#48496b" />
          </div>
          <div className="search_hot-card ms-3">
            <span>زنانه تن پوش حوله</span>
            <BiChevronLeft size={20} color="#48496b" />
          </div>
          <div className="search_hot-card ms-3">
            <span>کمربند یوگا</span>
            <BiChevronLeft size={20} color="#48496b" />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default SearchDrawer;
